function u() {
  var t = [], n = {};
  return {
    getSharedStrings: function() {
      return t;
    },
    getSharedString: function(e) {
      var r = n[e];
      return r === void 0 && (r = String(t.length), n[e] = r, t.push(e)), r;
    }
  };
}
export {
  u as default
};
//# sourceMappingURL=index.es477.js.map
